import type { FC } from 'react';

import { AnalyticsPeriodDropdown } from '@/shared';

import { UsageTimeFrame } from '../../types';

interface UsagePeriodDropdownProps {
    onChange: (timeFrame: UsageTimeFrame) => void;
    value: UsageTimeFrame;
}

const UsagePeriodDropdown: FC<UsagePeriodDropdownProps> = ({ onChange, value }) => {
    return (
        <AnalyticsPeriodDropdown
            onChange={onChange}
            options={[
                { label: '1 Week', value: UsageTimeFrame.WEEK },
                { label: '1 Month', value: UsageTimeFrame.MONTH },
                { label: '1 Quarter', value: UsageTimeFrame.QUARTER },
                { label: '1 Year', value: UsageTimeFrame.YEAR },
                { dividerBefore: true, label: 'All Time', value: UsageTimeFrame.ALL_TIME },
            ]}
            value={value}
        />
    );
};

export default UsagePeriodDropdown;
